import React from 'react';
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  Row,
  Col,
} from 'reactstrap';
import {useState} from 'react';
import Axios from 'axios';
import {useEffect} from 'react';
import ReactHtmlParser from 'react-html-parser';

import styles from './Events.module.css';
import {API_URL} from '../../ApiUrl.js';
import {Link} from 'react-router-dom';

function Events() {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');

  const getEvents = async () => {
    try {
      setLoading(true);
      const res = await Axios.get(`${API_URL}/api/event`);
      const sortEventsbyFav = res.data.sort((a, b) => b.favorite - a.favorite);
      setEvents(sortEventsbyFav);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString('fr-FR', {
      day: 'numeric',
      weekday: 'long',
      year: 'numeric',
      month: 'long',
    });
  
  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };
  
  return (
    <div className={styles.eventPage}>
      {loading && <p className={styles.loading}>Chargement...</p>}
      {error && (
        <p className={styles.errorMsg}>
          Une erreur est survenue, veuillez recharger la page.
        </p>
      )}

      <h1 className="title-centered"> Évènements À  venir</h1>

      {events
        .filter((item) => item.favorite === true)
        .map((item) => {
          const dateStart = item.dateStartEvent;
          const dateEnd = item.dateEndEvent;
          return (
            <div key={item.id} className={styles.featuredCardWrapper}>
              <Card className="card-event">
                <CardBody>
                  <div className={styles.headerCard}>
                    <Row>
                      <Col
                        md={{
                          size: 9,
                        }}
                        sm="12"
                      >
                        <Row>
                          <CardTitle>
                            <h3 className={`${styles.headerTitle} title-black`}>
                              {item.title}
                            </h3>
                          </CardTitle>
                        </Row>
                        <Row>
                          <CardText className="text-event">
                            Lieu de l&apos;Évènement : {item.localisation}
                          </CardText>
                          <CardText className="text-event">
                            {dateStart && dateEnd ? (
                              <>
                                Du {formatDate(dateStart)} au{' '}
                                {formatDate(dateEnd)}
                              </>
                            ) : dateStart ? (
                              <>Le {formatDate(dateStart)}</>
                            ) : (
                              ''
                            )}
                          </CardText>
                          <CardText className="text-event">
                            {item.timeStartEvent && item.timeEndEvent ? (
                              <>
                                De {item.timeStartEvent} À  {item.timeEndEvent}
                              </>
                            ) : item.timeStartEvent ? (
                              <> À Partir de {item.timeStartEvent}</>
                            ) : (
                              ''
                            )}
                          </CardText>
                        </Row>
                      </Col>
                      <Col>
                        <img
                          src={item.photoURL}
                          alt=""
                          className={styles.imageEvent}
                        />
                      </Col>
                    </Row>
                  </div>

                  <Row>
                    <Col
                      md={{
                        size: 12,
                      }}
                      sm="12"
                    >
                      <CardText className="text-event">
                        {ReactHtmlParser(item.content)}
                      </CardText>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          );
        })}

      <h1 className="title-centered">Autres Évènements</h1>

      <div className={styles.cardGroup}>
        {events
          .sort((a, b) => {
            const dateA = new Date(a.dateStartEvent);
            const dateB = new Date(b.dateStartEvent);
            return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
          })
          .map((item) => {
            if (item.favorite !== false) return null;

            const hasAnyPhoto =
              item.photoEventOne ||
              item.photoEventTwo ||
              item.photoEventThree ||
              item.photoEventFour;

            if (!hasAnyPhoto) return null;

            const photos = [
              item.photoEventOne || item.photoURL,
              item.photoEventTwo || item.photoURL,
              item.photoEventThree || null,
              item.photoEventFour || null,
            ];

            return (
              <div key={item.id} className={styles.pastCard}>
                <div className={styles.pastCardBody}>
                  <h3 className={styles.pastCardTitle}>{item.title}</h3>

                  <div className={styles.photoGrid}>
                    {photos.map((photo, index) =>
                      photo ? (
                        <div key={index} className={styles.photoWrapper}>
                          <CardImg
                            src={photo}
                            alt={item.title}
                            className={styles.photoImg}
                          />
                        </div>
                      ) : (
                        <div key={index} />
                      )
                    )}
                  </div>

                  <CardText className={styles.eventText}>
                    {ReactHtmlParser(item.content)}
                  </CardText>

                  <div className={styles.seeMoreWrapper}>
                    <Link to={`/events/${item.id}`} className={styles.seeMore} onClick={handleScrollToTop}>
                      Voir plus
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Events;
